import type { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import { HIGHLIGHT_PROPS } from "components/job/JobTable/Job/constants";
import useJobProps from "components/job/JobTable/Job/useJobProps";

export interface JobProps {
  title: string;
  id: string;
  archived: string;
}

const Job: FunctionComponent<JobProps> = ({ title, id, archived }) => {
  const { searchWords, classNames } = useJobProps(archived);

  return (
    <div className="flex flex-col">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords || []}
        textToHighlight={title || ""}
        className={classNames.title}
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords || []}
        textToHighlight={id || ""}
        className={classNames.id}
      />
    </div>
  );
};

export default Job;
